import UserStore from '@/store/user'

export default defineNuxtRouteMiddleware(async (to, from) => {
  const userStore = UserStore()
  const { currentUser } = storeToRefs(userStore)

  if (currentUser.value?.backstage) {
    return { name: 'dashboard' }
  } else if (to.name !== 'index') {
    return { name: 'auth-register' }
  }
})